import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DevicesAdapater } from './devices.adapater';
import { DevicesController } from './devices.controller';
import { DevicesService } from './devices.service';
import { DeviceRepo } from './repository/device.repository';
import { RfCodeRepo } from './repository/rf-code.repository';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      DeviceRepo,RfCodeRepo
    ])
  ],
  controllers: [DevicesController],
  providers: [DevicesService,DevicesAdapater,ApplicationExceptionHandler],
  exports:[DevicesService,DevicesAdapater]
})
export class DevicesModule {}
